import type { IconType } from "react-icons";
import { FaCode, FaTasks } from "react-icons/fa";
import { MdDesignServices, MdOutlineSupportAgent } from "react-icons/md";

/** Structural data only — translated copy lives in dict.aboutUs. */
export const aboutUsBanner = {
  image: "/assets/about-us/about-us.avif",
};

export type AboutFocusKey = "mission" | "vision" | "why" | "how";

export const aboutFocusKeys: AboutFocusKey[] = [
  "mission",
  "vision",
  "why",
  "how",
];

export type WhyChooseUsKey =
  | "experiencedTeam"
  | "customSolutions"
  | "endToEndService"
  | "onTimeDelivery"
  | "affordableTransparent"
  | "longTermPartnership";

export const whyChooseUsPoints: { key: WhyChooseUsKey; icon: string }[] = [
  {
    key: "experiencedTeam",
    icon: "/assets/about-us/why-choose-us/experienced-team.png",
  },
  {
    key: "customSolutions",
    icon: "/assets/about-us/why-choose-us/custom-solutions.png",
  },
  {
    key: "endToEndService",
    icon: "/assets/about-us/why-choose-us/end-to-end-service.png",
  },
  {
    key: "onTimeDelivery",
    icon: "/assets/about-us/why-choose-us/on-time-delivery.png",
  },
  {
    key: "affordableTransparent",
    icon: "/assets/about-us/why-choose-us/affordable-and-transparent.png",
  },
  {
    key: "longTermPartnership",
    icon: "/assets/about-us/why-choose-us/long-term-partnership.png",
  },
];

export type DepartmentKey =
  | "development"
  | "design"
  | "management"
  | "support";

export const departmentList: {
  key: DepartmentKey;
  Icon: IconType;
  image: string;
}[] = [
  {
    key: "development",
    Icon: FaCode,
    image: "/assets/about-us/departments/development.avif",
  },
  {
    key: "design",
    Icon: MdDesignServices,
    image: "/assets/about-us/departments/graphic-design.avif",
  },
  {
    key: "management",
    Icon: FaTasks,
    image: "/assets/about-us/departments/project-management.avif",
  },
  {
    key: "support",
    Icon: MdOutlineSupportAgent,
    image: "/assets/about-us/departments/customer-support.avif",
  },
];
